import { useRive, useStateMachineInput } from '@rive-app/react-canvas';
import React, { useEffect, useRef, useState } from 'react';
import getUrlAmbiente from '../../../../../utils/getUrlAmbiente';
import getVisemeNumber from './getVisemaNumber';

function AvatarRive({
  avatarUrl,
  width = 500,
  height = 500,
  visema = 0,
  audioUrl = null,
  visemas = [],
  setVisemas = () => {},
  onStart = () => {},
  onEnded = () => {},
  styles = {},
  playbackRate = 1,
}) {
  const stateMachineName = 'State Machine 1';
  const inputRiveName = 'visema';

  const audioInterval = useRef(null);
  const visemaIndex = useRef(-1);

  const audioRef = useRef(new Audio());
  const [currentAvatarUrl, setCurrentAvatarUrl] = useState(getUrlAmbiente(avatarUrl));

  const { rive, RiveComponent } = useRive({
    src: currentAvatarUrl,
    stateMachines: stateMachineName,
    autoplay: true,
  });

  const visemaInput = useStateMachineInput(
    rive,
    stateMachineName,
    inputRiveName
  );

  useEffect(() => {
    const processedUrl = getUrlAmbiente(avatarUrl);
    if (processedUrl !== currentAvatarUrl && rive) {
      setCurrentAvatarUrl(processedUrl);
      rive.load({
        src: processedUrl,
        stateMachines: stateMachineName,
        autoplay: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [avatarUrl, rive]);

  useEffect(() => {
    if (!visemaInput) return;

    try {
      // Verificar se o runtimeInput interno ainda é válido antes de definir o valor
      visemaInput.value = visema;
    } catch (error) {
      // Ignorar erros de definição de valor em inputs destruídos
      console.warn('Erro ao definir valor do visemaInput:', error);
    }
  }, [visema, visemaInput]);

  useEffect(() => {
    function playAudioWithVisemes() {
      audioRef.current.pause();
      audioRef.current.src = audioUrl;
      const audio = audioRef.current;

      if (onStart) {
        onStart(audio);
      }

      clearInterval(audioInterval.current);

      audioInterval.current = setInterval(() => {
        // Verificar se visemaInput ainda é válido antes de usar
        if (!visemaInput) {
          clearInterval(audioInterval.current);
          audioInterval.current = null;
          return;
        }

        if (visemas.length <= visemaIndex.current) {
          return;
        }

        const currentViseme =
          visemas[visemaIndex.current < 0 ? 0 : visemaIndex.current];

        const nextViseme =
          visemas.length > visemaIndex.current + 1
            ? visemas[visemaIndex.current + 1]
            : { time: 0 };

        // Verificar novamente se visemaInput ainda é válido antes de definir value
        if (visemaInput) {
          try {
            visemaInput.value = getVisemeNumber(currentViseme.value);
          } catch (error) {
            // Ignorar erros de definição de valor em inputs destruídos
            clearInterval(audioInterval.current);
            audioInterval.current = null;
          }
        }

        if (
          audio.currentTime * 1000 >= currentViseme.time &&
          nextViseme.time - audio.currentTime * 1000 < 50
        ) {
          visemaIndex.current = visemaIndex.current + 1;
          //visemaInput.value = 0;
        }
      }, 5);

      audio.playbackRate = playbackRate;
      audio.play();

      audio.onpause = () => {
        clearInterval(audioInterval.current);
        audioInterval.current = null;
        visemaIndex.current = -1;
        // Verificar se visemaInput ainda é válido antes de definir value
        if (visemaInput) {
          try {
            visemaInput.value = 0;
          } catch (error) {
            // Ignorar erros de definição de valor em inputs destruídos
            console.warn('Erro ao resetar visemaInput no onpause:', error);
          }
        }
      };

      audio.onended = () => {
        clearInterval(audioInterval.current);
        audioInterval.current = null;
        visemaIndex.current = -1;
        // Verificar se visemaInput ainda é válido antes de definir value
        if (visemaInput) {
          try {
            visemaInput.value = 0;
          } catch (error) {
            // Ignorar erros de definição de valor em inputs destruídos
            console.warn('Erro ao resetar visemaInput no onended:', error);
          }
        }
        setVisemas([]);
        if (onEnded) {
          onEnded();
        }
      };
    }

    if (audioUrl && visemas.length > 0) playAudioWithVisemes();

    // Cleanup function para limpar o interval quando o componente for desmontado
    return () => {
      clearInterval(audioInterval.current);
      audioInterval.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audioUrl, visemaInput, visemas]);

  return (
    <div style={{ width, height, ...styles }}>
      <RiveComponent />
    </div>
  );
}

export default AvatarRive;
